import type { Routes } from '@angular/router';
import { AuthenticationGuard } from '@core/guards/authentication.guard';
import { AuthorizationGuard } from '@core/guards/authorization.guard';
import { LayoutComponent } from '@core/layout/layout.component';

export const routes: Routes = [
  {
    path: '',
    canActivate: [AuthenticationGuard],
    component: LayoutComponent,
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
      },
      {
        path: 'forbidden',
        title: 'routes.forbidden',
        loadComponent: () => import('../shared/pages/forbidden/forbidden.component').then((c) => c.ForbiddenComponent),
      },
      {
        path: 'server-error',
        title: 'routes.serverError',
        loadComponent: () =>
          import('../shared/pages/server-error/server-error.component').then((c) => c.ServerErrorComponent),
      },
      {
        path: 'home',
        title: 'routes.home',
        loadComponent: () => import('../shared/pages/home/home.component').then((c) => c.HomeComponent),
      },
      {
        path: 'not-found',
        title: 'routes.notFound',
        loadComponent: () => import('../shared/pages/not-found/not-found.component').then((c) => c.NotFoundComponent),
      },
      {
        path: 'access-control',
        title: 'routes.accessControl.title',
        loadComponent: () =>
          import('../features/access-control/access-control.component').then((c) => c.AccessControlComponent),
        loadChildren: () => import('./access-control.routes').then((m) => m.accessControlRoutes),
      },
      {
        path: 'micare',
        title: 'routes.micare.title',
        canActivate: [AuthorizationGuard],
        data: { permission: 'micare:list' },
        loadChildren: () => import('./micare.routes').then((m) => m.micareRoutes),
      },
      {
        path: 'message-board',
        title: 'routes.messageBoard.title',
        loadChildren: () => import('./message-board.routes').then((m) => m.messageBoardRoutes),
      },
    ],
  },
  {
    path: 'sign-in',
    title: 'routes.signIn',
    loadComponent: () => import('../shared/pages/sign-in/sign-in.component').then((c) => c.SignInComponent),
  },
  {
    path: '**',
    redirectTo: 'not-found',
  },
];
